import styled from "styled-components";

export default styled.header`
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
`;
